<script>
  import { External, M } from '../../external';
  import Dropdown from '../../Common/Dropdown.svelte';
  import { onMount } from 'svelte';
  import BasicFilter from '../../Store/BasicFilter.svelte';
  import { DAY } from '../../Common/tools';
  import LmsAnalytics from '../analytics/LmsAnalytics.svelte';
  import { LmsUtils } from '../utils/LmsUtils';
  import { makeLmsRequest } from '../service/LmsClient';

  const ALL_CIRCLES_ITEM = {
    id: '',
    name: M.ALL_CIRCLES
  };

  let circles = [];
  let selectedCircle = ALL_CIRCLES_ITEM;
  let loading = true;
  let allProducts = [];
  let productIds = [];

  let onSelectedCircleChanged = (event) => {
    selectedCircle = event.detail.selected;
    productIds = getProductIds();
  };

  let now = new Date();
  let activePeriod = {
    label: M.LAST_SEVEN_DAYS,
    id: '7-days',
    from: new Date(now.getTime() - 6 * DAY),
    to: now
  };

  let onBasicFilterChange = (event) => {
    activePeriod = event.detail.period;
  };

  let getProductIds = () => {
    if (selectedCircle.id) {
      return allProducts.filter(product => product.circleId === selectedCircle.id).map(product => product.productId);
    } else {
      return allProducts.map(product => product.productId);
    }
  };

  onMount(async () => {
    circles = [
      ALL_CIRCLES_ITEM,
      ...(await LmsUtils.listCircles())
    ];

    let productsResult = await makeLmsRequest('/circle/products');
    if (productsResult.ok) {
      allProducts = await productsResult.json();
    }

    productIds = getProductIds();
    loading = false;
  });


</script>

<div style="display: flex; flex-direction: row; height: 100%;">

  <div class="account-settings col20" style="height: auto;">
    <div class="top-background-wrapper narrow-top-background dash-top-background">
      <div class="top-background">
        <div class="text-wrapper flex align-center flex-col-mobile align-left-mobile col20 f-left">
          <h1 class="members-title f-left t-center" style="margin-bottom: 0px;">{M.CIRCLE_DASHBOARD}</h1>
          <div class="flex align-center">
            <div class="f-left">
              <BasicFilter withFunnels={false} on:change={(event) => onBasicFilterChange(event)} period={activePeriod} />
            </div>
            <h4 class="ml-15 hide-mobile">{M.FOR}</h4>
            <Dropdown items={circles} activeItem={selectedCircle} on:change={onSelectedCircleChanged} class="ml-15" />
          </div>
        </div>
      </div>
    </div>
    <div class="content-wrapper">
      {#if !loading}
        {#key selectedCircle || activePeriod}
          <LmsAnalytics entity="{selectedCircle}" type="CIRCLE" activePeriod="{activePeriod}" productIds={productIds} style={{shadow: true}} />
        {/key}
      {/if}
    </div>
  </div>

</div>

